import StringUtils from '../utils/StringUtils';
import { NextImage } from './NextImage';

const BillerList = ({ billers, onSelectBiller,handleSelectCategory, selectedCategory }) => {
  return (
    <ul className="mt-6 mx-auto grid grid-cols-2 gap-6 sm:grid-cols-3 md:grid-cols-6 transition-all duration-500 ease-in-out">
      
      <button key={123} type="button" onClick={() => handleSelectCategory("back")} className="bg-transparent p-0 rounded-lg outline-none focus:outline-none active:shadow-outline-red transition-all duration-200 ease-in-out">
                    <li className="col-span-1 flex flex-col text-center bg-white rounded-lg overflow-hidden">
                      <div className="flex-1 flex flex-col">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-50 w-50" fill="none" viewBox="0 0 24 24" stroke="#b50808" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                          </svg>
                      </div>
                    </li>
                  </button>
      {
        billers.map((biller) => 
          <button key={biller.id} type="button" onClick={() => onSelectBiller(biller.id)} className="bg-transparent p-0 border border-gray-100 rounded-lg outline-none focus:outline-none hover:shadow-xl active:shadow-outline-red transition-all duration-200 ease-in-out">
            <li className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow overflow-hidden">
              <div className="flex-1 flex flex-col">
                <NextImage
                  alt={biller.name}
                  src={biller.image}
                  fullWidth={true}
                  priority
                  className="w-full h-auto"
                />
              </div>
              <div className="relative border-t border-gray-200 py-3">
                <p className="min-h-10 h-10 max-h-10 px-3 text-sm text-gray-800 leading-5 line-clamp-2">{biller.name}</p>
              </div>
            </li>
          </button>
        )
      }
    </ul>
  );
}

export default BillerList;